import { createStore } from "vuex";
import { fetchWishlistItems as apiFetchWishlistItems } from "../wishlist/api";

// Common Variable for BYK
const initialState = {
  outer_layer: { top: [], bottom: [] },
  mid_layer: { top: [], bottom: [] },
  base_layer: { top: [], bottom: [] },
};

export default createStore({
  state: {
    byk: {
      selectedProducts: JSON.parse(JSON.stringify(initialState)),
    },
    pdp: {
      productForm: {},
      firstLevelOptions: {}
    },
    wishlistContentDetailsList: [],
    wishlistProducts: [],
    isWishlistLoading: true,
    isWishlistModalOpen: false,
    renderOptionsInWishlistModal: false,
    showCreateNewListScreen: false,
    productToWishlist: {
      product: null,
      variant: null,
    },
    selectedWishlistDetails: null
  },

  getters: {
    getWishlistContentDetailsList: (state) => state.wishlistContentDetailsList,
  },

  mutations: {

    // BYK Mutations
    setBYKSelectedProduct(state, data) {
      // Ensure that data.layer and data.subcategory exist in state.selectedProducts
      if (state.byk.selectedProducts[data.layer] && state.byk.selectedProducts[data.layer][data.subcategory] !== undefined) {
        state.byk.selectedProducts[data.layer][data.subcategory] = data.value;
      } else {
        console.error('Invalid layer or subcategory');
      }
    },

    resetBYKSelectedProductsToInitialState(state) {
      // Reset the selectedProducts to the initial state
      Object.keys(state.byk.selectedProducts).forEach(layer => {
        Object.keys(state.byk.selectedProducts[layer]).forEach(subcategory => {
          state.byk.selectedProducts[layer][subcategory] = [];
        });
      });
    },

    // PDP Mutations
    setPDPProductForm(state,data){
      state.pdp.productForm[data.key] = data.value;
    },

    setPDPFirstLevelOptions(state, data){
      state.pdp.firstLevelOptions = data;
    },

    // Wishlist Mutations
    setWishlistContentDetailsList(state, list) {
      state.wishlistContentDetailsList = list;
    },

    setWishlistProducts(state, productArray) {
      state.wishlistProducts = productArray;
    },

    enableWishlistModal(state, value) {
      state.isWishlistModalOpen = value;
    },

    enableCreateNewListScreen(state, value) {
      state.showCreateNewListScreen = value;
    },

    setProductToOperateForWishlist(state, value) {
      state.productToWishlist.product = value.product;
      if (value.variant) {
        state.productToWishlist.variant = value.variant;
      }
    },


    setSelectedWishlist(state, value) {
      state.selectedWishlistDetails = value;
    },

    setIsWishlistLoading(state, value) {
      state.isWishlistLoading = value;
    },

    setIsRenderOptionsInWishlistModal(state, value) {
      state.renderOptionsInWishlistModal = value;
    }
  },

  actions: {

    // BYK Actions
    updateBYKSelectedProduct({ commit }, data) {
      commit("setBYKSelectedProduct", data);
    },

    resetBYKSelectedProducts({ commit }) {
      commit("resetBYKSelectedProductsToInitialState");
    },

    // PDP Actions
    updatePDPProductForm({ commit },data) {
      commit('setPDPProductForm',data);
    },

    updatePDPFirstLevelOptions({ commit },data) {
      commit('setPDPFirstLevelOptions',data);
    },

    // Wishlist Actions
    async fetchWishlistItems({ commit }) {
      try {
        const lists = await apiFetchWishlistItems();
        // Flattening the listcontents into a single array to obtain products
        const allListContents = lists.reduce((acc, list) => {
          return acc.concat(list.listcontents);
        }, []);
        
        commit('setIsWishlistLoading', true);
        commit("setWishlistContentDetailsList", lists);
        commit('setWishlistProducts', allListContents);
        commit('setIsWishlistLoading', false);
      } catch (error) {
        console.error("Error fetching wishlist products:", error);
      }
    },

    showWishlistModal({ commit }, value) {
      commit("enableWishlistModal", value);
    },

    toggleCreateNewListScreen({ commit }, value) {
      commit("enableCreateNewListScreen", value);
    },

    setProductToWishlist({ commit }, value) {
      commit("setProductToOperateForWishlist", value);
    },

    setSelectedWishlistDetails({ commit }, value) {
      commit("setSelectedWishlist", value)
    },

    setRenderOptionsInModal({ commit }, value) {
      commit("setIsRenderOptionsInWishlistModal", value);
    }
  },
});